import { _ as r } from "../internals/export.js";
import { d as t } from "../internals/descriptors.js";
import { a as e } from "../internals/an-object.js";
import { t as o } from "../internals/to-property-key.js";
import "../internals/object-define-property.js";
import { f as s } from "../internals/fails.js";
import { __exports as a } from "../../../_virtual/object-define-property.js";
r({
  target: "Reflect",
  stat: !0,
  forced: s(function () {
    Reflect.defineProperty(a.f({}, 1, {
      value: 1
    }), 1, {
      value: 2
    });
  }),
  sham: !t
}, {
  defineProperty: function defineProperty(r, t, s) {
    e(r);
    var n = o(t);
    e(s);
    try {
      return a.f(r, n, s), !0;
    } catch (r) {
      return !1;
    }
  }
});